var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login__footer mt-1"},[_c('span',{staticClass:"font--normal -md -color-text"},[_vm._v("®CYURICA Co., Ltd.")])])}]

export { render, staticRenderFns }